import { TIPTAP_CAPTION_TYPE } from "./../ricos-content/consts";
import { captionConverter } from "./converter/caption-converter";
import { captionTiptapExtension } from "./tiptap/caption-tiptap-extension";
import { figureTiptapExtension } from "./tiptap/figure-tiptap-extension";
const pluginFigure = {
  type: TIPTAP_CAPTION_TYPE,
  config: {},
  pmMarkConverters: [],
  pmNodeConverters: [captionConverter],
  tiptapExtensions: [figureTiptapExtension, captionTiptapExtension]
};
export {
  pluginFigure
};
//# sourceMappingURL=editor.js.map
